import { z } from 'zod';

import type {
  PatchAdminV1StoresStoreIdReturnsIdBody,
  Return,
} from '@nucleus-commerce/api-client/admin';

export const returnDetailsSchema = z.object({
  staffNote: z.string().trim().max(2000, { error: 'returns:validation.noteLength' }),
  returnShippingPaidBy: z.enum(['customer', 'store']),
});

export type ReturnDetailsForm = z.infer<typeof returnDetailsSchema>;

export function fromReturnDetails(
  ret: Pick<Return, 'staffNote' | 'returnShippingPaidBy'>,
): ReturnDetailsForm {
  return {
    staffNote: ret.staffNote ?? '',
    returnShippingPaidBy: ret.returnShippingPaidBy ?? 'customer',
  };
}

export function toReturnDetailsPatch(
  values: ReturnDetailsForm,
): PatchAdminV1StoresStoreIdReturnsIdBody {
  return { staffNote: values.staffNote || null, returnShippingPaidBy: values.returnShippingPaidBy };
}
